export default __webpack_public_path__ + "static/media/rnr-sports-table-3.8aa70805.webp";